<template>
  <div>
    <BaseDialog
      v-model="showDialog"
      dialogIcon="mdi-alert"
      title="Avvik"
      btnActionName="Lagre"
      @action="save"
    >
      <template v-slot>
        <v-form ref="form" v-model="valid" autocomplete="off">
          <v-text-field
            class="textFieldError"
            v-model="aberration.title"
            color="primary"
            label="Navn"
            filled
            :rules="[(v) => !!v || 'Navn må fylles ut!']"
          ></v-text-field>

          <v-textarea
            class="textFieldError"
            v-model="aberration.description"
            color="primary"
            label="Beskrivelse"
            filled
            :rules="[(v) => !!v || 'Beskrivelse må fylles ut!']"
          ></v-textarea>

          <v-btn
            v-if="aberration.attachments && aberration.attachments.length > 0"
            class="mb-2"
            small
            color="primary"
            @click="$refs.dropzone.addAttachment()"
          >
            Legg til fil
          </v-btn>
          <FileDropzone
            ref="dropzone"
            v-model="aberration.attachments"
            :close="false"
          />
        </v-form>
      </template>
    </BaseDialog>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import BaseDialog from "@/components/shared/dialog/BaseDialog.vue";
import FileDropzone from "@/components/shared/attachments/FileDropzone.vue";

export default Vue.extend({
  name: "EditProfileDialog",
  props: {
    value: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      aberration: { attachments: [] },
      valid: false,
    };
  },
  watch: {
    showDialog(value) {
      if (!value) {
        this.reset();
      }
    },
  },
  methods: {
    save() {
      const isValid = (this as any).$refs.form.validate();
      if (isValid) {
        this.$emit("save", this.aberration);
      }
    },
    reset() {
      this.aberration = { attachments: [] };
      (this as any).$refs?.form?.reset();
    },
  },
  computed: {
    showDialog: {
      get(): boolean {
        return this.value;
      },
      set(value: boolean) {
        this.$emit("input", value);
      },
    },
  },

  components: {
    BaseDialog,
    FileDropzone,
  },
});
</script>
